import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, showNotification, refreshView as refreshViewAction } from 'react-admin';

import request from '../../../../network/request';
import resourceConfig from './config';

class CreateCSVButton extends Component {
    state = {
      executing: false
    }
    handleClick = async() => {
        const { showNotification, record, refreshView } = this.props;

        this.setState({
          executing: true
        });
        let data = {
          id: record.id
        }
        let response = null;
        try {
          response = await request({
            apiService: 'shoes',
            path: '/admin/print/func/csv',
            urlParams: data,
            method: 'POST',
          })
        } catch (e) {
          console.error(e);
        }
        if (response === null || !response.ok) {
          showNotification(`resources.${resourceConfig.name}.csvAction.errorMessage`, 'error');
        } else {
          showNotification(`resources.${resourceConfig.name}.csvAction.successMessage`, 'success');
        }
        
        this.setState({
          executing: false
        }, refreshView);
    };
    

    render() {
      const {
        buttonProps = {}
      } = this.props;

      return (
          <Button
            label={`resources.${resourceConfig.name}.csvAction.action`}
            disabled={this.state.executing}
            {...buttonProps}
            onClick={this.handleClick}
          />
      );
    }
}

export default connect(undefined, { 
  showNotification, 
  refreshView: refreshViewAction 
})(CreateCSVButton);